import { IUserContextModel } from "./model/IUserContextModel";
import { Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class UserContextService extends ServiceBase {

    public async getUserContext(organizationId?: string,
    ): Promise<Result<IUserContextModel>>
    {
        let url = "/UserContext?organizationId="+organizationId+"&";
        let terms: string[] = [];

        let termsUrl = terms.join("&");

        var result = await this.requestJson<IUserContextModel>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }
}